import KycUpdateModal from "../../../components/kyc/KycUpdateModal";
import {
  KYC_VERIFICATION_STATUS,
  KYC_DOC_TYPES,
} from "../../../../config/const";
import { getKycDocuments } from "../../../../redux/user/actions";
import moment from "moment";

import React, { useEffect, useState } from "react";
import { Button, Container, Table } from "react-bootstrap";
import LeftArrow from "../../../../assets/images/icons/back.png";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import LeftBarSports from "../../../components/LeftBarSports";
import { useNavigate, useParams } from "react-router-dom";

const KycDetail = () => {
  const navigate = useNavigate();
  const { type } = useParams();
  const [kycRecord, setKycRecord] = useState(null);
  const [updateModalConfig, setUpdateModalConfig] = useState({
    showModal: false,
    data: null,
  });

  useEffect(() => {
    // if doc type is invalid then return user back
    if (type && !KYC_DOC_TYPES.some((f) => f.key === type)) {
      navigate(-1);
    }

    loadKycDoc();
  }, [type]);

  // Get kyc docs
  const loadKycDoc = async () => {
    const response = await getKycDocuments();
    if (response) {
      const filteredKyc = response?.data?.data?.find((f) => f?.type === type);
      setKycRecord(filteredKyc);
    }
  };

  return (
    <>
      <HeaderAfterLogin />
      <main className="main">
        <div className="main-page">
          <LeftBarSports />
          <div className="main-content">
            <Container>
              <div className="inner-wrapper">
                <div className="right-content-wrapper">
                  <div className="headingSec">
                    <div className="back-link" onClick={() => navigate(-1)}>
                      <img src={LeftArrow} alt="LeftArrow" /> <h1>KYC</h1>
                    </div>
                  </div>
                  <div className="KycSection">
                    <div className="d-flex">
                      <div>
                        <p className="kyc-details">
                          <span> Document type :</span>{" "}
                          {
                            KYC_DOC_TYPES.find((f) => f.key === kycRecord?.type)
                              ?.name
                          }
                        </p>
                        <p className="kyc-details">
                          <span>Status :</span> {kycRecord?.status}
                        </p>
                        <p className="kyc-details">
                          <span>Document Id :</span> {kycRecord?.documentId}
                        </p>
                        <p className="kyc-details">
                          <span>Created At :</span>{" "}
                          {moment(kycRecord?.createdAt).format(
                            "dddd DD MMM, hh:mm A"
                          )}
                        </p>
                      </div>
                      <div className="ms-auto">
                        <Button
                          disabled={
                            kycRecord?.status ===
                            KYC_VERIFICATION_STATUS.Approved
                          }
                          onClick={() => {
                            setUpdateModalConfig({
                              showModal: true,
                              data: kycRecord,
                            });
                          }}
                          style={{
                            marginRight: "40px",
                          }}
                        >
                          Update
                        </Button>
                      </div>
                    </div>
                    <p className="kyc-details">
                      <span>Documents</span>
                    </p>
                    <div className="table-responsive mt-4 kyc-table">
                      <Table className="text-white ">
                        <thead>
                          <tr>
                            <th scope="col">#</th>
                            <th scope="col">View Type</th>
                            <th scope="col">File type</th>
                            <th scope="col">Status</th>
                            <th scope="col">Comment</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(kycRecord &&
                            kycRecord?.documents?.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <th scope="row">{index + 1}</th>

                                  <td>{item?.viewType}</td>
                                  <td>{item?.docFileType}</td>
                                  <td>{item?.docStatus}</td>
                                  <td>{item?.comment}</td>
                                </tr>
                              );
                            })) ||
                            null}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
              {updateModalConfig.showModal && (
                <KycUpdateModal
                  modalConfig={updateModalConfig}
                  setUpdateModalConfig={setUpdateModalConfig}
                  loadKycDoc={loadKycDoc}
                />
              )}
            </Container>
          </div>
        </div>
      </main>
    </>
  );
};
export default KycDetail;
